<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="4">
        <v-alert dense text type="info">
          {{ counter }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="primary" @click="register()" block>+</v-btn>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Usuário</th>
          <th>Nome</th>
          <th>Função</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.username }}</td>
          <td>{{ item.name }}</td>
          <td>
            <v-btn x-small v-bind:color="colorRole(item.role)">{{item.role | formatRole}}</v-btn>
          </td>
          <td>
            <v-btn small color="primary" @click="view(item.id)">detalhes</v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    counter: 0,
    dialog_loading: false
  }),
  created: function() {
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/user", { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.dialog_loading = false;
          me.current = response.data;
          me.counter = me.current.length;
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar usuarios!");
        });
    },
    view: function(id) {
      router.push({ path: `/user/${id}` });
    },
    register: function() {
      router.push({ path: "/user/0" });
    },
    colorRole: function(status) {
      var ret = "default";
      if (status == 0) {
        ret = "success";
      } else if (status == 128) {
        ret = "info";
      }
      return ret;
    }
  },
  filters: {
    formatRole: function(value) {
      var ret = "desconhecido";
      if (value == 0) {
        ret = "Administrador";
      } else if (value == 128) {
        ret = "Usuário";
      }
      return ret;
    }
  }
};
</script>